<template>
  <div class="row mt-4 mb-2">
    <div class="col-12 mb-2">
      <div class="header-legend">
        <span>Leyenda de Bandeja</span>
      </div>
    </div>

    <div class="col-12 col-md-6">
      <div class="d-flex">
        <div class="legend-box yellow" />
        <div class="legend-box yellow light" />
      </div>

      <div class="footer-legend mt-1 mt-md-0">
        <span>Pendiente de Discusión</span>
      </div>
    </div>

    <div class="col-12 col-md-6 mt-2 mt-md-0">
      <div class="d-flex">
        <div class="legend-box red" />
        <div class="legend-box red light" />
      </div>

      <div class="footer-legend mt-1 mt-md-0">
        <span>Recomendado a Reevaluación</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SourceLegend',
};
</script>

<style lang="scss">
.header-legend {
  color: #3f5b60;
  font-size: 0.875rem;
}

.footer-legend {
  color: #727272;
  font-size: 0.75rem;
}

.legend-box {
  height: 0.375rem;
  width: 100%;
}

.legend-box.yellow {
  background: #fdeaaf;
}

.legend-box.yellow.light {
  opacity: 0.5;
}

.legend-box.red {
  background: #ffcece;
}

.legend-box.red.light {
  opacity: 0.5;
}
</style>
